/* The Little Things — global UI behaviors (vanilla, no dependencies). */
(function () {
  'use strict';

  /* ---------- Overlay ---------- */
  var overlay = document.createElement('div');
  overlay.className = 'page-overlay';
  document.body.appendChild(overlay);

  var openDrawer = null;
  var lastFocused = null;

  function focusables(el) {
    return el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function drawerOpen(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.dataset.open = 'true';
    overlay.dataset.open = 'true';
    document.body.setAttribute('data-drawer-open', '');
    openDrawer = drawer;
    var f = focusables(drawer);
    window.requestAnimationFrame(function () {
      if (f.length) f[0].focus();
    });
    document.querySelectorAll('[aria-controls="' + drawer.id + '"], [data-menu-open]').forEach(function (t) {
      if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'true');
    });
  }

  function drawerClose() {
    if (!openDrawer) return;
    openDrawer.dataset.open = 'false';
    overlay.dataset.open = 'false';
    document.body.removeAttribute('data-drawer-open');
    document.querySelectorAll('[data-menu-open]').forEach(function (t) {
      if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
    });
    openDrawer = null;
    if (lastFocused) lastFocused.focus();
  }

  window.tltDrawer = { open: drawerOpen, close: drawerClose };

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-menu-open]'))) {
      e.preventDefault();
      drawerOpen(document.querySelector('[data-menu-drawer]'));
    } else if ((t = e.target.closest('[data-cart-open]'))) {
      e.preventDefault();
      drawerOpen(document.querySelector('[data-cart-drawer]'));
    } else if (e.target.closest('[data-menu-close], [data-cart-close]')) {
      e.preventDefault();
      drawerClose();
    } else if (e.target === overlay) {
      drawerClose();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { drawerClose(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.slice.call(focusables(openDrawer));
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  /* ---------- Gift note character counter ---------- */
  function bindGiftNotes(root) {
    (root || document).querySelectorAll('[data-gift-note-input]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      var count = input.closest('[data-gift-note]').querySelector('[data-gift-note-count]');
      if (!count) return;
      var limit = parseInt(count.dataset.limit, 10) || 250;
      var template = count.textContent.trim();
      var update = function () {
        var left = limit - input.value.length;
        count.textContent = template.replace(/\d+/, String(left));
      };
      input.addEventListener('input', update);
      update();
    });
  }
  bindGiftNotes(document);
  window.tltBindGiftNotes = bindGiftNotes;

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Reveal-on-scroll (single authored moment) ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Scroller dots ---------- */
  document.querySelectorAll('[data-scroller]').forEach(function (scroller) {
    var dotsWrap = document.querySelector('[data-scroller-dots="' + scroller.id + '"]');
    if (!dotsWrap) return;
    var items = scroller.children;
    var dots = [];
    for (var i = 0; i < items.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + items.length);
      (function (idx) {
        b.addEventListener('click', function () {
          items[idx].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
      })(i);
      dotsWrap.appendChild(b);
      dots.push(b);
    }
    var setActive = function () {
      var sl = scroller.scrollLeft;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - scroller.offsetLeft - sl);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    };
    scroller.addEventListener('scroll', setActive, { passive: true });
    setActive();
  });
})();
